exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-pic[data-v-2ee03d10] {\n  width: 150px;\n  border-radius: 50%;\n}\n", ""]);

// exports
